import { $http } from "@/utils/http";

import { SET_DELIVERY_METHODS_LIST, SET_DELIVERY_METHODS_LIST_LOADING, SET_DELIVERY_FILIAL } from "../mutation-types";

import { GET_DELIVERY_METHODS_LIST, GET_DELIVERY_FILIAL } from "../action-types";

const state = {
    deliveryMethodsList: null,
    deliveryMethodsListLoading: false,
    filialList: null,
};

const getters = {
    deliveryMethodsList: state => state.deliveryMethodsList,
    deliveryMethodsListLoading: state => state.deliveryMethodsListLoading,
    getFilialList: state => state.filialList,
};

const actions = {
    [GET_DELIVERY_FILIAL]: async ({ commit }) => {
        // commit(SET_DELIVERY_METHODS_LIST_LOADING, true);
        try {
            const response = await $http.get(`v1/affiliates`);
            commit(SET_DELIVERY_FILIAL, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            // commit(SET_DELIVERY_METHODS_LIST_LOADING, false);
        }
    },

    [GET_DELIVERY_METHODS_LIST]: async ({ commit }) => {
        commit(SET_DELIVERY_METHODS_LIST_LOADING, true);
        try {
            const response = await $http.get(`v1/delivery-methods`);
            commit(SET_DELIVERY_METHODS_LIST, response.data);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_DELIVERY_METHODS_LIST_LOADING, false);
        }
    },
};

const mutations = {
    [SET_DELIVERY_FILIAL](state, list) {
        state.filialList = list;
    },
    [SET_DELIVERY_METHODS_LIST](state, list) {
        state.deliveryMethodsList = list;
    },
    [SET_DELIVERY_METHODS_LIST_LOADING](state, status) {
        state.deliveryMethodsListLoading = status;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
